import { useSnackbar } from "../components/Snackbar/index.js";
const copy = async (value)=>new Promise((resolve, reject)=>{
        setTimeout(async ()=>{
            try {
                if (navigator.clipboard && navigator.clipboard.write) {
                    const blob = new Blob([
                        value
                    ], {
                        type: 'text/plain'
                    });
                    const item = new ClipboardItem({
                        'text/plain': blob
                    });
                    await navigator.clipboard.write([
                        item
                    ]);
                } else await navigator.clipboard.writeText(value);
                resolve();
            } catch (error) {
                reject(error);
            }
        }, 0);
    });
const useCopyToClipboard = ()=>{
    const { errorSnackbar, infoSnackbar } = useSnackbar();
    const copyToClipboard = async (value, message)=>{
        try {
            await copy(value);
            infoSnackbar(message ?? 'Copied');
        } catch (_e) {
            errorSnackbar('Copy to clipboard failed');
        }
    };
    return copyToClipboard;
};
export { useCopyToClipboard };

//# sourceMappingURL=useCopyToClipboard.js.map